<template>
  <!-- 视频 -->
  <div class="videoing">
    <el-row>
      <el-col :span="20" :offset="2">
        <div class="video" @contextmenu.prevent="menuPlayer()">
          <div class="video_show" v-show="videoShow">
            <p class="imgs"><img src="../assets/video_logo.png" alt=""></p>
            <div>
              <img src="../assets/img/video/loading.gif" alt />
            </div>
          </div>
          <video-player
            class="video-player vjs-custom-skin palsyer"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            :src="video_url"
            v-show="!videoShow"
            @play="onPlayerPlay($event)"
            controlslist="nodownload"
          ></video-player>
        </div>
      </el-col>

      <!-- 右边 -->
    </el-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "vide",
  data() {
    return {
      video_url:'',
      WidthSize: "",
      video: "",
      loading: true,
      videoShow: true,

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",  
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: 'video_url' //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    to, from, next();
  },
  created() {
    setTimeout(() => {
      this.loading = false;
      this.videoShow = false;
    }, 3000);
  },
  beforeDestroy() {
    this.handleResizeing();
  },
  mounted:function() {
    // this.onPlayerPlay(this.$refs.videoPlayer.player);
    this.getvideo()
    console.log(this.video_url)
  },
  watch: {},
  methods: {
    async getvideo () {
       await axios
      .get("http://111.229.214.104:8000/book/video/?id=" + this.$route.query.id + "&points=" + this.$route.query.points + "&token=" + this.$route.query.token)
      .then(response => {
        this.video_url = response.data.video_url
        console.log(response.data.video_url)
        this.playerOptions['sources'][0]['src'] = this.video_url; 
      });
      console.log(this.video_url)
    },
    // videoClick() {
    //   console.log("wode");
    // },
    handleResize(e) {
      this.WidthSize = e.currentTarget.innerWidth;
      // console.log(this.WidthSize)
    },
    handleResizeing() {
      this.WidthSize = window.outerWidth;
    },
    fullScreen() {
      const player = this.$refs.videoPlayer.player;
      player.requestFullscreen(); //调用全屏api方法
      player.isFullscreen(true);
      player.play();
    },
    onPlayerPlay(player) {
      player.play();
      // console.log(player)
    },
    onPlayerPause(player) {
      alert("pause");
      console.log(player);
    },
    menuPlayer() {
      return false;
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  }
};
</script>


<style lang="scss">
.bottm{
  display: none;
}
.imgs > img{
  position: relative;
  top: 250px;
  left: 3%;
}
.video {
  overflow: hidden;
  width: 100%;
  margin: 0.2rem auto 0rem;
  z-index: 999 !important;
  position: relative;
  height: 17.18rem;
  // background-color: red;
  .video_show {
    width: 100%;
    height: 13.18rem;
    position: absolute;
    z-index: 999 !important;
    background-color: #000;
    div {
      width: 100%;
      height: 13.18rem;
      position: relative;
      img {
        position: absolute;
        top: 50%;
        width: 1rem;
        height: 1rem;
        margin-top: -0.5rem;
      }
    }
  }
  .palsyer {
    width: 100%;
    position: absolute;
  }
}
.video_right {
  margin-top: 0.2rem;
  background-color: #000;

  .title {
    float: left;
    margin-left: 20px;
    position: relative;
    height: 100px;
    width: 80%;
    // margin-top: 20px;
    // background-color: yellow;
    overflow: hidden;
    img {
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 15px;
    }
    span {
      display: inline-block;
      // margin-top: -10px;
      position: absolute;
      width: 120px;
      color: #ffffff;
      left: 20px;
      font-size: 16px;
    }
  }
  .right_content {
    width: 80%;
    height: 50vh;
    // background-color: red;
    // margin-top: 20px;
  }
  .video-js .vjs-big-play-button{
    position: absolute!important;
    top: 10px!important;
    left: 10px!important;
  }
}
</style>
	